
export enum SJQXChecks {
  SCGHSJ = 'delete_registered_data', //删除挂号数据
  CKLRSJ = 'view_profit_data', //查看利润数据
  DCDYQX = 'export_print_permission', //导出/打印权限
  YSCKJYCX = 'doctor_view_transaction',//医生查看交易查询
  YSCKJZMK = 'doctors_view_visit_module',//医生查看就诊模块
  YSSJK = 'revenue_data',//营收数据块
  YSCKJZSJ = 'doctor_view_visit_data',//医生查看就诊数据
  YSCKLSBL = 'doctor_view_history_record',//医生查看历史病历
  WJSXGJZYS = 'unsettled_modify_doctor',//未结算修改接诊医生
  YJSXGJZYS = 'settled_modify_doctor',//已结算修改接诊医生
  YSKFXGJG = 'prescription_modify_price',//医生开方修改价格
  QTRXGBLCF = 'other_modify_record',//其他人修改病历/处方
  YSGZZDCDYQX = 'doctor_station_export_print', //医生工作站导出/打印权限
  KFGZZCKLRSJ = 'warehouse_view_inventory_profit', //库房工作站查看利润数据
  KFGZZDCDYQX = 'warehouse_export_print_permission', //库房工作站导出/打印权限
  SFDCDYQX = 'charge_setting_export_print', //收费导出/打印权限
  SYCKHRSJH = 'sy_view_patient_phone', //首页查看患者手机号
  YSMZCKHRSJH = 'yszd_view_patient_phone', //医生门诊查看患者手机号
  KSKDCKHRSJH = 'kskd_view_patient_phone', //快速开单查看患者手机号
  TJFXCKHRSJH = 'tjfx_view_patient_phone', //统计分析查看患者手机号
  GLSZCKHRSJH = 'glsz_view_patient_phone', //管理设置查看患者手机号
  SFCKHRSJH = 'sf_view_patient_phone', //随访查看患者手机号
  GHCKHZSJH = 'registration_view_phone', //挂号查看患者手机号权限
  YYCKHZSJH = 'appointment_view_phone', //预约查看患者手机号权限
  YSGZZCKHZSJH = 'doctor_station_view_phone', //医生工作站查看患者手机号权限
  YJZCKHZSJH = 'medical_station_view_phone', //医技站查看患者手机号权限
  HYGLCKHZSJH = 'member_manage_view_phone', //会员管理查看患者手机号权限
  HSGZZCKHZSJH = 'nurse_station_view_phone', //护士工作站查看患者手机号权限
  HZGLCKHZSJH = 'patient_manage_view_phone', //患者管理查看患者手机号权限
  SFXGZFFS = 'charge_setting_update_pay_method', //收费修改支付方式
}

export const JQXCheckOptions = [
  SJQXChecks.SCGHSJ,
  SJQXChecks.CKLRSJ,
  SJQXChecks.DCDYQX,
  SJQXChecks.YSCKJYCX,
  SJQXChecks.YSCKJZMK,
  SJQXChecks.YSSJK,
  // SJQXChecks.YSCKJZSJ,
  SJQXChecks.YSCKLSBL,
  SJQXChecks.WJSXGJZYS,
  SJQXChecks.YJSXGJZYS,
  SJQXChecks.YSKFXGJG,
  SJQXChecks.QTRXGBLCF,
  SJQXChecks.YSGZZDCDYQX,
  SJQXChecks.KFGZZCKLRSJ,
  SJQXChecks.KFGZZDCDYQX,
  SJQXChecks.SFDCDYQX,
  SJQXChecks.SYCKHRSJH,
  SJQXChecks.YSMZCKHRSJH,
  SJQXChecks.KSKDCKHRSJH,
  SJQXChecks.TJFXCKHRSJH,
  SJQXChecks.GLSZCKHRSJH,
  SJQXChecks.SFCKHRSJH,
  SJQXChecks.GHCKHZSJH,
  SJQXChecks.YYCKHZSJH,
  SJQXChecks.YSGZZCKHZSJH,
  SJQXChecks.YJZCKHZSJH,
  SJQXChecks.HYGLCKHZSJH,
  SJQXChecks.HSGZZCKHZSJH,
  SJQXChecks.HZGLCKHZSJH,
  SJQXChecks.SFXGZFFS,
]

export function getSJQXChecksName(value: SJQXChecks) {
  switch (value) {
    // 首页
    case 'doctors_view_visit_module':
      return '医生查看就诊模块'
    case 'revenue_data':
      return '营收数据块'
    // 通用版归在挂号 口腔的话在首页
    case 'delete_registered_data':
      return '删除挂号数据'
    case 'registration_view_phone':
      return '查看患者手机号'

    // 预约
    case 'appointment_view_phone':
      return '查看患者手机号'

    // 统计分析
    case 'view_profit_data':
      return '查看利润数据'
    case 'export_print_permission':
      return '导出/打印权限'
    case 'doctor_view_transaction':
      return '医生查看交易查询'

    // 医生门诊
    case 'doctor_view_visit_data':
      return '医生查看就诊数据'
    case 'doctor_view_history_record':
      return '医生查看历史病历'
    case 'unsettled_modify_doctor':
      return '未结算修改接诊医生'
    case 'settled_modify_doctor':
      return '已结算修改接诊医生'
    case 'prescription_modify_price':
      return '医生开方修改价格'
    case 'other_modify_record':
      return '其他人修改病历/处方'

    //  医生工作站
    case 'doctor_station_export_print':
      return '导出/打印权限'
    case 'doctor_station_view_phone':
      return '查看患者手机号'

    // 收费
    case 'charge_setting_export_print':
      return '导出/打印权限'
    case 'charge_setting_update_pay_method':
      return '修改支付方式'

    // 护士工作站
    case 'nurse_station_view_phone':
      return '查看患者手机号'

    // 医技站
    case 'medical_station_view_phone':
      return '查看患者手机号'

    // 会员管理
    case 'member_manage_view_phone':
      return '查看患者手机号'

    // 患者管理
    case 'patient_manage_view_phone':
      return '查看患者手机号'

    // 库房工作站
    case 'warehouse_view_inventory_profit':
      return '查看利润数据'
    case 'warehouse_export_print_permission':
      return '导出/打印权限'

    // 查看患者手机号
    case 'sy_view_patient_phone':
      return '查看患者手机号'
    case 'yszd_view_patient_phone':
      return '查看患者手机号'
    case 'kskd_view_patient_phone':
      return '查看患者手机号'
    case 'tjfx_view_patient_phone':
      return '查看患者手机号'
    case 'glsz_view_patient_phone':
      return '查看患者手机号'
    case 'sf_view_patient_phone':
      return '查看患者手机号'
    default:
      break
  }
}

// 医生查看就诊模块
export enum YSCKJZMKType {
  ZYXCKZJDHZ = 1,
  YXCKDTSYDHZ = 2,
}


export const YSCKJZMKTypeOptions = [
  YSCKJZMKType.ZYXCKZJDHZ,
  YSCKJZMKType.YXCKDTSYDHZ,
]

export function getYSCKJZMKTypeName(type: YSCKJZMKType) {
  switch (type) {
    case 1:
      return '只允许查看自己的患者'
    case 2:
      return '允许查看当天所有的患者'
    default:
      break
  }
}

// 营收数据块
export enum YSSJKType {
  YCDQXKCK = 1,
  JGLYQXKCK = 2,
  ZDCYKCK = 99
}

export const YSSJKTypeOptions = [
  YSSJKType.YCDQXKCK,
  YSSJKType.JGLYQXKCK,
  YSSJKType.ZDCYKCK,
]

export function getYSSJKTypeName(type: YSSJKType) {
  switch (type) {
    case 1:
      return '有首页菜单权限可查看'
    case 2:
      return '仅管理员权限可查看'
    case 99:
      return '指定成员可查看'
    default:
      break
  }
}

//删除挂号数据
export enum SCGHSJType {
  YGHCDKBJ = 1,
  JGLYKBJ = 2,
  ZDCYKBJ = 99
}

export const SCGHSJTypeOptions = [
  SCGHSJType.YGHCDKBJ,
  SCGHSJType.JGLYKBJ,
  SCGHSJType.ZDCYKBJ,
]

export const SCGHSJTypeOption = [
  SCGHSJType.JGLYKBJ,
  SCGHSJType.ZDCYKBJ,
]


export function getSCGHSJTypeName(type: SCGHSJType) {
  switch (type) {
    case 1:
      return '有挂号菜单权限可编辑'
    case 2:
      return '仅管理员可编辑'
    case 99:
      return '指定成员可编辑'
    default:
      break
  }
}

// 查看利润数据 
export enum CKLRSJType {
  YCDQXKCK = 1,
  JGLYKCK = 2,
  ZDCYKCK = 99
}

export const CKLRSJTypeOptions = [
  CKLRSJType.YCDQXKCK,
  CKLRSJType.JGLYKCK,
  CKLRSJType.ZDCYKCK,
]

export function getCKLRSJTypeName(type: CKLRSJType, moduleName: any) {
  switch (type) {
    case 1:
      return `有${moduleName}菜单权限可查看`
    case 2:
      return '仅管理员权限可查看'
    case 99:
      return '指定成员可查看'
    default:
      break
  }
}

// 导出/打印权限
export enum DCDYQXType {
  YCDQXKDCDY = 1,
  JGLYKBJ = 2,
  ZDCYKBJ = 99
}

export const DCDYQXTypeOptions = [
  DCDYQXType.YCDQXKDCDY,
  DCDYQXType.JGLYKBJ,
  DCDYQXType.ZDCYKBJ,
]

export function getDCDYQXTypeName(type: DCDYQXType, moduleName: any) {
  switch (type) {
    case 1:
      return `有${moduleName}菜单权限可导出/打印`
    case 2:
      return '仅管理员权限可导出/打印'
    case 99:
      return '指定成员可导出/打印'
    default:
      break
  }
}


// 修改支付方式
export enum XGZFFSType {
  YCDQXKXG = 1,
  JGLYKXG = 2,
  ZDCYKXG = 99
}

export const XGZFFSTypeTypeOptions = [
  XGZFFSType.YCDQXKXG,
  XGZFFSType.JGLYKXG,
  XGZFFSType.ZDCYKXG,
]

// 修改支付方式
export function getXGZFFSTypeName(type: XGZFFSType, moduleName: any) {
  switch (type) {
    case 1:
      return `有${moduleName}菜单权限可修改`
    case 2:
      return '仅管理员权限可修改'
    case 99:
      return '指定成员可修改'
    default:
      break
  }
}

// 医生查看交易查询
export enum YSCKJYCXType {
  ZYXCKZJDHZ = 1,
  YXCKSYDHZ = 2,
}

export const YSCKJYCXTypeOptions = [
  YSCKJYCXType.ZYXCKZJDHZ,
  YSCKJYCXType.YXCKSYDHZ,
]

export function getYSCKJYCXTypeName(type: YSCKJYCXType) {
  switch (type) {
    case 1:
      return '只允许查看自己的患者'
    case 2:
      return '允许查看所有的患者'
    default:
      break
  }
}

// 医生查看就诊数据
export enum YSCKJZSJType {
  ZYXCKZJDHZ = 1,
  ZYXCKBKSDHZ = 3,
  YXCKSYDHZ = 2
}

export const YSCKJZSJTypeOptions = [
  YSCKJZSJType.ZYXCKZJDHZ,
  YSCKJZSJType.ZYXCKBKSDHZ,
  YSCKJZSJType.YXCKSYDHZ,
]

export function getYSCKJZSJTypeName(type: YSCKJZSJType) {
  switch (type) {
    case 1:
      return '只允许查看自己的患者'
    case 3:
      return '只允许查看本科室的患者'
    case 2:
      return '允许查看所有的患者'
    default:
      break
  }
}

// 医生查看历史病历
export enum YSCKLSBLType {
  ZYXCKZJJZDLSBLCF = 1,
  YXCKSYDLSBLCF = 2
}

export const YSCKLSBLTypeOptions = [
  YSCKLSBLType.ZYXCKZJJZDLSBLCF,
  YSCKLSBLType.YXCKSYDLSBLCF,
]

export function getYSCKLSBLTypeName(type: YSCKLSBLType) {
  switch (type) {
    case 1:
      return '只允许查看自己接诊的历史病历处方'
    case 2:
      return '允许查看所有的历史病历处方'
    default:
      break
  }
}


// 公共
export enum commonType {
  YCDQXKBJ = 1,
  JGLYQXKBJ = 2,
  ZDCYKBJ = 99
}

export const commonTypeOptions = [
  commonType.YCDQXKBJ,
  commonType.JGLYQXKBJ,
  commonType.ZDCYKBJ,
]

export function getCommonTypeName(type: commonType, moduleName: any) {
  switch (type) {
    case 1:
      return `有${moduleName}菜单权限可编辑`
    case 2:
      return '仅管理员权限可编辑'
    case 99:
      return '指定成员可编辑'
    default:
      break
  }
}

export enum yskfType {
  YES = 1,
  NO = 0,
}

export const yskfTypeOptions = [
  yskfType.YES,
  yskfType.NO,
]

//张冰川让我改的04.10
export function getYSKFTypeName(type: yskfType) {
  switch (type) {
    case 0:
      return '允许'
    case 1:
      return '不允许'
    default:
      break
  }
}

export enum xgblcfType {
  BXZ = 1,
  JCKBKXG = 0,
  BYXCK = 2
}

export const xgblcfypeOptions = [
  xgblcfType.BXZ,
  xgblcfType.JCKBKXG,
  xgblcfType.BYXCK,
]

export function getXGBLCFTypeName(type: xgblcfType) {
  switch (type) {
    case 1:
      return '不限制'
    case 0:
      return '仅查看不可修改'
    case 2:
      return '不允许查看'
    default:
      break
  }
}


export function getModuleName(value: SJQXChecks) {
  switch (value) {
    case 'doctors_view_visit_module':
      return '首页'
    case 'revenue_data':
      return '首页'
    case 'delete_registered_data':
      return '首页'
    case 'sy_view_patient_phone':
      return '首页'
    case 'view_profit_data':
      return '统计分析'
    case 'export_print_permission':
      return '统计分析'
    case 'doctor_view_transaction':
      return '统计分析'
    case 'tjfx_view_patient_phone':
      return '统计分析'
    case 'doctor_view_visit_data':
      return '医生门诊'
    case 'doctor_view_history_record':
      return '医生门诊'
    case 'unsettled_modify_doctor':
      return '医生门诊'
    case 'settled_modify_doctor':
      return '医生门诊'
    case 'prescription_modify_price':
      return '医生门诊'
    case 'other_modify_record':
      return '医生门诊'
    case 'yszd_view_patient_phone':
      return '医生门诊'
    case 'doctor_station_export_print':
      return '医生工作站'
    case 'warehouse_view_inventory_profit':
      return '库房工作站'
    case 'warehouse_export_print_permission':
      return '库房工作站'
    case 'charge_setting_export_print':
      return '收费'
    case 'registration_view_phone':
      return '挂号'
    case 'appointment_view_phone':
      return '预约'
    case 'doctor_station_view_phone':
      return '医生工作站'
    case 'medical_station_view_phone':
      return '医技站'
    case 'member_manage_view_phone':
      return '会员管理'
    case 'nurse_station_view_phone':
      return '护士工作站'
    case 'patient_manage_view_phone':
      return '患者管理'
    case 'charge_setting_update_pay_method':
      return '收费'
    case 'kskd_view_patient_phone':
      return '快速开单'
    case 'glsz_view_patient_phone':
      return '管理设置'
    case 'sf_view_patient_phone':
      return '随访'
  }
}
